import React from "react";
// bg-gray-800 dark:bg-slate-800
const Preloader = ({ loading }: { loading: boolean }) => {
  return loading ? (
    <div className="fixed inset-0 bg-gray-800 dark:bg-slate-800 bg-opacity-50 dark:bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-slate-800 p-3 rounded-full flex flex-col items-center justify-center shadow">
        <div className="rounded-full border-2 border-gray-300 border-t-2 border-t-purple-500 h-12 w-12 mb- animate-spin"></div>
      </div>
    </div>
  ) : null;
};

export default Preloader;
